module.exports = __webpack_public_path__ + "images/169_160.jpg";